$("body").on("click", ".accordion", function(){
    $(this).stop().toggleClass("active");
    $(this).next(".panel").stop().slideToggle();
  });

$("body").on("mouseenter", ".hover_block .imgText p [data-image]", function(){
  console.log($(this).attr("data-image"));
  var image = ".hoverimg"+$(this).attr("data-image");
  if($(".hover_block .imageCol img"+image).length > 0) {
  	$(".hover_block .imageCol img").css({"display": "none"});
  	$(".hover_block .imageCol img"+image).css({"display": "block"});
  }
});

 
$(window).on("scroll", function(event){
  
  if($("body").hasClass("template-product")) {
    if($(this).scrollTop() > ($(".product-area").offset().top + 200)) {
      $("#shopify-section-sticky-product").addClass("active");
    }
    else {
      $("#shopify-section-sticky-product").removeClass("active");
    }
  }
});